export default __webpack_public_path__ + "static/media/R5C_8209.ece946eb.jpg";